import { render, staticRenderFns } from "./TrainingDatesForm.vue?vue&type=template&id=1dc54875&"
import script from "./TrainingDatesForm.vue?vue&type=script&lang=js&"
export * from "./TrainingDatesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports